<template>
    <div class="EstimateDetail mx-auto my-2">
        <Nav></Nav>
        <div id="loading" v-if="showLoading">
            <img
            class="loadingImg"
            src="../../assets/images/loading.gif"
            alt="loading..."
            width="200"
            />
        </div>
        <!-- 報價單資料 -->
        <div class="estimateData d-flex flex-column">
            <div>
                <span class="leftData">編號：{{EstimateId}}</span>
                <span>姓名：{{estimateData.userName}}</span>
            </div>
            <div>
                <span class="subtitle leftData">一、報價日期：</span>
                <span>{{showDate(estimateData.estimateDate)}}</span>
            </div>
            <div>
                <span class="subtitle leftData">二、地點：</span>
                <span>{{estimateData.area}}</span>
            </div>
            <div>
                <span class="subtitle leftData">三、學校名稱：</span>
                <span class="fontOrg">{{estimateData.school}}</span>
            </div>
            <div>
                <span class="subtitle leftData">四、課程名稱：</span>
                <span class="fontOrg">{{estimateData.couse}}</span>
            </div>
            <div>
                <span class="subtitle leftData">五、住宿房型：</span>
                <span class="fontOrg">{{estimateData.room}}</span>
            </div>
            <div>
                <span class="subtitle leftData">六、課程總堂數：</span>
                <span class="fontOrg">{{estimateData.courseWeek}}</span>
            </div>
        </div>

        <!-- 項目費用 -->
        <div calss="memberEstimateInfo ">
            <div class="d-flex justify-content-left table-border mx-auto">
                <span class="subtitle InfoName">項目名稱</span>
                <span class="subtitle InfoCol pl-1 my-0" >價格</span>
                <span class="subtitle InfoCol pl-1 my-0" >單位</span>
                <span class="subtitle InfoCol pl-1 my-0" >數量</span>
                <span class="subtitle InfoCol pl-1 my-0" >總額</span>
            </div>
            <div class="d-flex justify-content-left table-border mx-auto mt-0" v-for="item in memberEstimateInfo">
                <span class="fontOrg InfoName" v-html="unescape(item.itemName)"></span>
                <span class="InfoCol pl-1" >{{item.price}}</span>
                <span class="InfoCol pl-1" >{{item.unit}}</span>
                <span class="InfoCol pl-1" >{{item.quantity}}</span>
                <span class="InfoCol bkYellow pl-1" >{{item.total}}</span>
            </div>
        </div>

        <!-- 合計 -->
        <div class="table-border d-flex flex-column mx-auto">
            <div class=" d-flex justify-content-between mx-1">
                <span class="subtitle">合計</span>
                <span class="subtitle">{{estimateMoney.originalAmount}}</span>
            </div>
            <div class="d-flex justify-content-between mx-1">
                <div>
                    <span class="fontOrg">匯率</span>
                    <span class="fontOrg">1{{estimateMoney.originalCurrency}}</span>
                </div>
                
                <div>
                    <span class="fontOrg">{{estimateMoney.changeCurrency}}:</span>
                    <span class="fontGreen">{{estimateMoney.changeRate}}</span>
                </div>

                <div>
                    <span>費用預估:</span>
                    <span class="subtitle">{{estimateMoney.changeAccount}}</span>
                </div>
            </div>
            <div class="d-flex" >
                <span class="fontRed mx-auto" style="">以上報價值含學費及住宿費用</span>
            </div>
            <div class="d-flex">
                <span class="fontBrown mx-auto">(本資料僅供參考，實際交易匯率請依台中銀行美金現鈔賣出匯率)</span>
            </div>
        </div>
        <!-- 備註費用 -->
        <div class="d-flex table-border mx-auto">
            <div class="subtitle" style="width:10%">
                備註 
            </div>            
            <div>
                <span class="fontBrown">{{estimateNote}}</span><br>
                <span class="fontRed">不含下列費用:</span><br>
                <div class="bkYellow d-flex"> 
                    <span class=" mx-auto">其他費用</span>
                </div>
                
                <div class="d-flex justify-content-left" v-for="item in estimateOtherFee">
                    <span style="width:60%" v-html="unescape(item.itemName)"></span>
                    <span style="width:20%">{{item.unit}}</span>
                    <span style="width:25%">{{item.price}}</span>
                </div>
                <div class="bkYellow d-flex"> 
                    <span class=" mx-auto">當地費用</span>
                </div>
                <div class="d-flex justify-content-left" v-for="item in estimateOther">
                    <span style="width:60%" v-html="unescape(item.itemName)"></span>
                    <span style="width:20%">{{item.unit}}</span>
                    <span style="width:25%">{{item.price}}</span>
                </div>
                <div class="d-flex justify-content-left">
                    <span style="width:60%"></span>
                    <span style="width:20%">小計</span>
                    <span style="width:25%" class="bkYellow subtitle">{{estimateOtherPrice}}</span>
                </div>
                <span class="fontRed">最後報價以學校invoice及當時匯率為準</span>
            </div>
        </div>
        <!-- 備註 -->
        <div class="my-2">
            <div>備註:</div>
            <div>1. 本報價單有效期限為報價日期後七天。</div>
            <div>2. 持觀光簽證為59天，超過則須在當地申請延簽，延簽費用依學校規定。</div>
            <div style="color:red;">3. 上述費用為預估，依匯率、個人花費、課程及個人的電費使用而有所差異。</div>
            <div>4. 暑假期間機票漲幅高，建議學生提早購買。</div>
            <div style="color:red;">5. 實際金額以學校收取的項目及費用為準。</div>
        </div>
        <!-- 其他備註 -->
        <div class="bkLtYellow my-2">
            <div class="mb-3">
                <span class="subtitle ">其他備註:</span>
            </div>
            <div v-html="unescape(EstimateRemarkTable)"></div>
        </div>
        <!-- 負責顧問 -->
        <div>
            <div>負責顧問：{{estimateData.consultant}}</div>
        </div>
    </div>
</template>

<script>
import Nav from '@/components/Nav'
import {app} from '@/main'
import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'

export default {
    name: 'EstimateDetail',
    components:{
        Nav,
    },
    data () {
        return {
            showLoading:'',
            estimateData:{},
            memberEstimateInfo:[],
            estimateMoney:[],
            estimateNote:'',
            estimateOtherFee:[],
            estimateOther:[],
            estimateOtherPrice:'',
            estimateTotalPrice:'',
            EstimateRemarkTxt:'',
            EstimateRemarkTable:'',
            EstimateId:'',
        }
    },
    methods:{
        unescape(str) {
            const div = document.createElement('div');
            div.innerHTML = str;
            return div.textContent;
        },
        GetEstimateDetailData(){
            this.showLoading = true;

            const api =`${process.env.APIPATH}/api/Estimate/GetEstimateDetailData`;
            const inputdata = 
            {
                "EstimateId":this.EstimateId
            };

            axios.post(api, inputdata)
                .then((response) => {
                    this.showLoading = false;
                    if(response.data.isSuccess){ 
                        this.estimateData = response.data.estimateData
                        this.memberEstimateInfo = response.data.memberEstimateInfo
                        this.estimateMoney = response.data.estimateMoney
                        this.estimateNote = response.data.estimateNote
                        this.estimateOtherFee = response.data.estimateOtherFee
                        this.estimateOther = response.data.estimateOther
                        this.estimateOtherPrice = response.data.estimateOtherPrice
                        this.estimateTotalPrice = response.data.estimateTotalPrice
                        this.EstimateRemarkTxt = response.data.etimateRemarkTxt
                        this.EstimateRemarkTable = response.data.estimateRemarkTable
                    }else{
                        console.error("There was an error!", response.data.message);
                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                });
        },
        showDate(date){
            return moment(date).format('yyyy-MM-DD');
        },
    },
    created(){
        this.EstimateId = this.$route.params.estimateId;
        this.GetEstimateDetailData();
    },
}
</script>






// WEBPACK FOOTER //
// src/components/line/EstimateDetail.vue